import axios, { AxiosResponse } from "axios";
import apiClient from "./apiClient";
import Cookies from "js-cookie";

export const createOfd = async (
    requestBody:any
  ) => {
    try {
      const token = Cookies.get("access_token"); 
  
      const response: AxiosResponse = await apiClient.post(
        `${process.env.REACT_APP_URL_MAIN_SERVICE}/operator/ofd`,
        requestBody,
        {
          headers: {
            Authorization: `Bearer ${token}`, 
            "Content-Type": "application/json", 
          },
        }
      );
  
      return response.data;
    } catch (error) {
      console.error("Ошибка при создании ОФД:", error);
      throw error;
    }
  };

export const updateOfd = async (ofdId: number, data: any): Promise<any> => {
    try {
      const token = Cookies.get("access_token");
      const response: AxiosResponse<any> = await apiClient.put(
        `${process.env.REACT_APP_URL_MAIN_SERVICE}/operator/ofd/${ofdId}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Ошибка при обновлении ОФД:", error);
      throw error;
    }
  };

export const uploadShepCertificate = async (file: File, password: string): Promise<any> => {
  try {
    const token = Cookies.get("access_token");
    const formData = new FormData();
    formData.append("file", file);

    const response: AxiosResponse<any> = await apiClient.post(
      `${process.env.REACT_APP_URL_MAIN_SERVICE}/operator/shep-cert/upload`,
      formData,
      {
        params: { password },
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Ошибка загрузки сертификата:", error);
    throw error;
  }
};

export const getShepCertificateMetadata = async (): Promise<any> => {
  try {
    const token = Cookies.get("access_token");
    const response: AxiosResponse<any> = await apiClient.get(
      `${process.env.REACT_APP_URL_MAIN_SERVICE}/operator/shep-cert/metadata`,
      {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Ошибка получения метаданных сертификата:", error);
    throw error;
  }
};

export const downloadShepCertificate = async (): Promise<ArrayBuffer> => {
  try {
    const token = Cookies.get("access_token");
    const response: AxiosResponse<ArrayBuffer> = await apiClient.get(
      `${process.env.REACT_APP_URL_MAIN_SERVICE}/operator/shep-cert/download`,
      {
        responseType: "arraybuffer",
        headers: {
          "Authorization": `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Ошибка скачивания сертификата:", error);
    throw error;
  }
};